import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ExternalLeadSourceSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: ExternalLeadSourceSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: ExternalLeadSourceSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<ExternalLeadSourceSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderBaseUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">API Base Url</label>
          <Controller
            control={control}
            rules={{
              required: 'API Base Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name="baseUrl"
            defaultValue={props.data?.baseUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="API Base Url"
                name={name}
                value={value}
                onChange={onChange}
                id="baseUrl"
              />
            )}
          />
          <ErrorMessage>{errors?.baseUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Tiktok Leads Api Settings
        </h4>
        <div className="row gutter-10">
          {renderBaseUrl()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
